import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16d180fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-container" }
const _hoisted_2 = { class: "inner-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatureCard = _resolveComponent("FeatureCard")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, {
        type: "flex",
        justify: "center",
        align: "middle",
        gutter: [20, 0]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_FeatureCard, {
                icon: _ctx.IconPng1,
                title: "为什么选择编程",
                desc: "提升思维能力",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.linkItem('WhyLearnProgram')))
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_FeatureCard, {
                icon: _ctx.IconPng3,
                title: "优秀作品展示",
                desc: "历届活动优秀作品展示",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.linkItem('UserExcellent')))
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}